import { InfluencerListView } from './view/InfluencerList.view';
import {
  ListModeVM,
  useInfluencerListViewModel,
  useListMode,
  usePagedInfluencerListViewModel,
} from './view-model/InfluencerList.viewModel';

const PagedList = (p: { listMode: ListModeVM }) => {
  const vm = usePagedInfluencerListViewModel();

  return <InfluencerListView {...vm.value} listMode={p.listMode} />;
};

const ClientSideList = (p: { listMode: ListModeVM }) => {
  const vm = useInfluencerListViewModel();

  return <InfluencerListView {...vm.value} listMode={p.listMode} />;
};

export const InfluencerListNewPage = () => {
  const listMode = useListMode();

  return listMode.useOldList ? (
    <ClientSideList listMode={listMode} />
  ) : (
    <PagedList listMode={listMode} />
  );
};
